import React, { createContext, ReactNode, useContext, useState } from 'react';
import { CorporateClub } from './types/corpclub-type';

type AllProfilesContextData = {
  setAllProfiles: React.Dispatch<React.SetStateAction<CorporateClub[]>>;
  allProfiles: CorporateClub[];
};

type PropsChildren = {
  children: ReactNode;
};

export const Context = createContext({} as AllProfilesContextData);

const AllProfilesContext = ({ children }: PropsChildren) => {
  const [allProfiles, setAllProfiles] = useState<CorporateClub[]>([]);

  const values = {
    setAllProfiles,
    allProfiles,
  };

  return <Context.Provider value={values}>{children}</Context.Provider>;
};

export const useAllProfilesContext = () => {
  const context = useContext(Context);
  return context;
};

export default AllProfilesContext;
